export enum MedicineEnum {
    NameAndStrength = 'nameAndStrength',
    Dosis = 'dosis',
    ToDate = 'toDate',
    FromDate = 'fromDate',
}

export const MedicineTranslations: Record<MedicineEnum, { en: string[]; da: string[] }> = {
    [MedicineEnum.NameAndStrength]: {
        en: ['name and strength'],
        da: ['Navn og styrke'],
    },
    [MedicineEnum.Dosis]: {
        en: ['dose'],
        da: ['Dosis'],
    },
    [MedicineEnum.ToDate]: {
        en: ['to date'],
        da: ['til dato'],
    },
    [MedicineEnum.FromDate]: {
        en: ['from date'],
        da: ['fra dato'],
    },
};